import { U as Url } from './url.min.js';

/**
 * **Hotel Net Solutions | One Page Booking**
 *
 * @exports bs_276
 * @category engines
 */
function factory({ window, document, thn }) {
  const engine = {};
  let hidePriceWidget;

  /**
    * @memberOf module:bs_276
    * @see {@link onStateChange}
    *
    * @param {object} ctx - The context object.
    */
  engine.onStateChange = thn.debounce(function (ctx) {
    thn.pageCheck();
  }, 400);

  /**
    * @memberOf module:bs_276
    * @see {@link is_user_logged}
    *
    * @param {object} ctx - The context object.
    */
  engine.isUserLogged = function isUserLogged(ctx) {

    const isLogged = !!document.querySelector('.signed-in');

    return isLogged;
  };

  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    const dataLayer = window.dataLayer;

    if (dataLayer && !thn.onepageBookingconfirmObserver) {
      // Create function to delete observer upon need
      const stopObserver = function () {
        thn.onepageBookingconfirmObserver?.cancel();
        delete thn.onepageBookingconfirmObserver;
      };

      thn.onepageBookingconfirmObserver = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
        if (message.event === 'transactionId' && ctx.widget.setData().isSet()) {
          ctx.widget.save();
          stopObserver();
        }
      }, true);

      thn.pageUnload(stopObserver);
    }

  };

  engine.boot = function boot() {

    const datalayer = window && window.dataLayer;

    if (!thn.hotelnetsolutionsDatalayerObserver && datalayer) {
      thn.hotelnetsolutionsDatalayerObserver = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
        setTimeout(thn.pageCheck, 1800);
      });
      thn.shutdown(() => {
        thn.hotelnetsolutionsDatalayerObserver.cancel();
        thn.hotelnetsolutionsDatalayerObserver = null;
      });
    }

    // Create an delegate to update the language
    if (engine._isMobile() && !thn.hotelnetsolutionsLanguageUndelegateMobile) {
      thn.hotelnetsolutionsLanguageUndelegateMobile = thn.delegate('click', '.dd-li:not(.active-element)', function () {
        // reset the language and check the page
        thn.languageCheck().then(function ({ changed }) {
          if (!changed && thn.data.pageName === 'Rooms and Rates') {
            thn.pageCheck();
          }
        });
      });
    }

    if (!engine._isMobile() && !thn.hotelnetsolutionsLanguageUndelegateDesktop) {
      thn.hotelnetsolutionsLanguageUndelegateDesktop = thn.debounce(function () {
        // reset the language and check the page
        thn.languageCheck().then(function ({ changed }) {
          if (!changed) {
            thn.pageCheck();
          }
        });

      }, 500);

      thn.observeDom(document.querySelector('.navbar-collapse .navbar-right dropdown'), thn.hotelnetsolutionsLanguageUndelegateDesktop, {
        childList: true,
        subtree: false,
        attributes: false,
      });
    }

    // Observer to update the mapping
    const container = engine._isMobile() ? document.querySelector('opb-app') : document.querySelector('#basket-wrap');

    if (container && !thn.hotelnetsolutionsPageUpdater) {
      // Debounce the effects of the observer
      const doRefresh = thn.debounce(() => {
        thn.languageCheck().then(function ({ changed }) {
          if (!changed && thn.widgets.price.isTargetPage()) {
            thn.widgets.price.refresh();
          }
        });
      }, 1000);

      const languageRefresh = thn.debounce(thn.languageCheck, 1000);

      thn.hotelnetsolutionsPageUpdater = function thnHotelnetsolutionsPageUpdater(mutations) {
        thn.pageCheck();
        // On desktop, we do not refresh the price widget
        // if the mutation is not from the "#basket-wrap" element (and subchilds)
        const loader = document.querySelector('.lds-roller');
        const basketWrapMutation = [...mutations].map((mutation) => mutation.target && mutation?.target?.classList && [...mutation.target.classList].filter((targetClass) => (targetClass.match(/basket/i) || {}).length)).filter((mapResult) => !thn.empty(mapResult));
        const currencyWrapMutation = [...mutations].map((mutation) => mutation.type === 'characterData' && mutation.target?.parentElement?.className?.includes('currency-symbol')).filter(Boolean);
        const languageMutation = [...mutations].map((mutation) => mutation.type === 'characterData' && mutation.target?.data?.match(/Total|Gesamtpreis/)).filter(Boolean);

        const isRoomsAndRatesPage = thn.data.pageName === 'Rooms and Rates';
        const isOnePageBooking = window.location.hostname.includes('onepagebooking');
        const shouldRefreshRoomsAndRates = isRoomsAndRatesPage && !loader && (engine._isMobile() || basketWrapMutation.length || currencyWrapMutation.length || languageMutation.length);
        const shouldLanguageCheck = isOnePageBooking && languageMutation.length && !isRoomsAndRatesPage && !loader;

        if (shouldRefreshRoomsAndRates) {
          doRefresh();
        }

        if (shouldLanguageCheck) {
          languageRefresh();
        }
      };

      thn.observeDom(container, thn.hotelnetsolutionsPageUpdater, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }

    thn.shutdown(function () {
      if (thn.hotelnetsolutionsDatalayerObserver) {
        delete thn.hotelnetsolutionsDatalayerObserver;
      }

      if (thn.hotelnetsolutionsLanguageUndelegateMobile) {
        thn.hotelnetsolutionsLanguageUndelegateMobile();
        delete thn.hotelnetsolutionsLanguageUndelegateMobile;
      }

      if (thn.hotelnetsolutionsLanguageUndelegateDesktop) {
        thn.stopObserveDom(document.querySelector('.navbar-collapse .navbar-right dropdown'), thn.hotelnetsolutionsLanguageUndelegateDesktop);
        delete thn.hotelnetsolutionsLanguageUndelegateDesktop;
      }

      if (thn.hotelnetsolutionsPageUpdater) {
        thn.stopObserveDom(container, thn.hotelnetsolutionsPageUpdater);
        delete thn.hotelnetsolutionsPageUpdater;
      }
    });
  };

  /**
     * @memberOf module:bs_276
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const containerBody = document.body;

    if (containerBody && !hidePriceWidget) {
      hidePriceWidget = () => {
        if (window.location.pathname.match(/packages|angebot/) && thn.widgets.price.isVisible()) {
          thn.widgets.price.hide();
        }
      };

      thn.observeDom(containerBody, hidePriceWidget, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.pageUnload(function () {
        if (hidePriceWidget) {
          hidePriceWidget.cancel();
          thn.stopObserveDom(containerBody, hidePriceWidget);
          hidePriceWidget = null;
        }
      });
    }
  };

  /**
   * @memberOf module:bs_276
   * @see {@link boot}
   *
   */
  engine._isMobile = function _isMobile() {
    return !!document.querySelector('body.mobile-view');
  };

  /**
   * @memberOf module:bs_276
   * @see {@link language_check}
   *
   * @param {object} ctx - The context object.
   */
  engine.languageCheck = function languageCheck(ctx) {
    return new Promise(function (resolve, reject) {
      // Hotel Net Solutions BE
      let aux = (document.querySelector('.navbar-collapse .navbar-right li:nth-child(3) .dropdown-value') || {}).textContent || '';
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      // Harrys Home Homepages
      aux = ((document.querySelector('.langNavi .active a') || {}).textContent || '').toLowerCase();
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      // Addlers Innsbruck
      aux = ((document.querySelector('.language-switcherTop .active') || {}).title || '').toLowerCase();
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      // Bold Hotels
      aux = ((document.querySelector('.language .active ') || {}).textContent || '').toLowerCase();
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      // Hotel Arnica Scuol
      aux = document.querySelector('body').getAttribute('data-language');
      if (aux && ctx.langs.test(aux)) {
        if (aux === 'ch') {
          resolve('de');
        } else { resolve(aux); }
        return;
      }

      // The Flamingo && The Oceans
      aux = (thn.data.accountUserId === 1049144 && !window.location.hostname.match(/onepagebooking/)) && window.location.hostname.split('.')?.[1];
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      // Goodmans Living Apartment Hotel
      aux = (thn.data.propertyId === 1163068 && !window.location.hostname.match(/onepagebooking/)) && (thn.parseUrlParameter('lang') || 'de');
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      const lang = window.location.pathname.match(ctx.urlRe);
      aux = lang && lang.length > 1 && lang[1];
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_276
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new Url(ctx.baseUrl);
    const validUrl = (url.host.match(/onepagebooking|malisgarten|josefshof/) || url.path.match(/booking|buchen/)) && !url.path.match(/package/);

    if (validUrl) {

      // https://onepagebooking.com/east?arrival=04.08.2020&departure=06.08.2020&adults=2&lang=de&rooms=1&children=0&currencyCode=EUR

      url.query.arrival = '[date_begin]';
      url.query.departure = '[date_end]';
      url.query.currencyCode = '[currency]';
      url.query.lang = '[language]';
      url.query.adults = '[adults]';
      url.query.children = '[children]';

      // export into ctx.new_url
      ctx.newUrl = url.decode(url.toString());

      if (thn.empty(ctx.newData.dateBegin)
        || thn.empty(ctx.newData.dateEnd)) {
        // invalid
        ctx.newUrl = '';
      } else {
        // Format of dates: yyyy/mm/dd -> dd.mm.yyyy
        ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3.$2.$1');
        ctx.newData.dateEnd = ctx.newData.dateEnd && ctx.newData.dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3.$2.$1');
      }
    } else {
      // This is not a valid BE URL
      ctx.newUrl = '';
    }

    return ctx;
  };

  /**
   * @memberOf module:bs_276
   * @this thn.widgets.price
   * @see {@link Price#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine._priceParseDataCommon = function _priceParseDataCommon() {
    const widgetData = {};
    const calendarMobileElm = document.querySelector('.active-section #calendar-and-sticky-wrap');

    if (window.location.pathname.match(/packages|angebot/) && thn.data.accountUserId !== 1045929) {
      // CS has requested that for all hotels with this BE we avoid showing PW in packages rooms
      return widgetData;
    }

    if ((thn.data.accountUserId === 1036128 && thn.parseUrlParameter('ratetype'))
      || (thn.data.accountUserId === 1037313 && (thn.parseUrlParameter('roomtype') || (document.querySelectorAll('.grid-items .grid-item') || {}).length === 1))) {
      widgetData.priceSpecial = 1;
    }

    // Dates
    // Try to get the date data from window object (get last element from the array)
    if (!thn.empty(window.duetto) && !thn.empty(window.duetto.initialConfig) && !thn.empty(window.duetto.initialConfig.events) && !thn.empty(window.duetto.initialConfig.events.slice(-1))) {
      widgetData.dateBegin = (window.duetto.initialConfig.events.slice(-1)[0].sd || '').replace(/-/g, '/');
      widgetData.dateEnd = (window.duetto.initialConfig.events.slice(-1)[0].ed || '').replace(/-/g, '/');
    }

    // If window object doesn't exists, get the data from the HTML
    if (!widgetData.dateBegin || !widgetData.dateEnd) {
      // We have a couple of date formats to have into account:
      //   " 04.03.21 "," 04/03/2021 ", " 04-03-21 " and  " Do., 11.02.2021 "
      // Luckily all dates satisfies DD/MM/YY
      const dateRaw = (document.querySelector('#section-2 > div:nth-child(1) .container .desktop-preview > div > p.big, #section-2 .mobile-preview .big, #basket-wrap .basket-column:nth-child(3) .booked-elements.ng-star-inserted') || {}).textContent || '';

      const dateRawMatches = dateRaw.match(/\d{2}[./-]\d{2}[./-]\d{2,4}/g) || {};

      // 'date_raw_matches' must have two items
      if (dateRawMatches.length === 2) {
        const dateStartMatches = dateRawMatches[0].match(/(\d{2})[./-](\d{2})[./-](\d{2,4})/);
        const dateEndMatches = dateRawMatches[1].match(/(\d{2})[./-](\d{2})[./-](\d{2,4})/);

        if (!thn.empty(dateStartMatches) && !thn.empty(dateEndMatches)) {
          // If year is in 2 digits, transform it to 4 digits
          // On year 2099 we should find a better way to solve it
          const yearDateBegin = dateStartMatches[3].length === 2 ? `20${dateStartMatches[3]}` : dateStartMatches[3];
          const yearDateEnd = dateEndMatches[3].length === 2 ? `20${dateEndMatches[3]}` : dateEndMatches[3];

          widgetData.dateBegin = `${yearDateBegin}/${dateStartMatches[2]}/${dateStartMatches[1]}`;
          widgetData.dateEnd = `${yearDateEnd}/${dateEndMatches[2]}/${dateEndMatches[1]}`;
        }
      }
    }
    if (engine._isMobile() && calendarMobileElm) {
      widgetData.set = false;
    }

    // Prices & Currency
    // By default the price is in euros
    widgetData.currency = thn.getCurrencyCode(document.querySelector('.currency-symbol-left')?.textContent) || thn.parseCurrency(document.querySelector('.room-lowest-price')?.textContent) || 'EUR';

    return widgetData;
  };

  /**
   * @memberOf module:bs_276
   * @this thn.widgets.price
   * @see {@link Price#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceParseData_v1 = function priceParseData_v1(ctx) {
    // Define empty widgetData in case that we need to do an early exist (multiple rooms case)
    // We must return or an empty object or a widgetData with all the data
    let widgetData = {};

    if ((document.querySelectorAll('#rooms-grid > div') || {}).length > 1) {
      return widgetData;
    }
    // Now that we know that is the single rooms case
    // we can asign the price_parse_data_common values to widgetData
    // Add exception here if possible
    widgetData = engine._priceParseDataCommon();

    this.logger.debug('-----  SINGLE ROOM  -----');

    // Guests

    const guestArray = [...document.querySelectorAll('#guests-config-wrap input')].map((el) => thn.parseNumber(el.value));

    const [adults, ...childrenArray] = guestArray;

    const children = childrenArray.reduce((a, b) => a + b, 0);

    widgetData.adults = adults;
    widgetData.children = children;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Rooms
    // This BE creates a room-list element for each number of rooms selected
    // We count the number of those elements to know the number of rooms that the user will select
    widgetData.rooms = (document.querySelectorAll('.col-md-12 > div >.desktop-preview-wrap.ng-star-inserted .guests-in-rooms-wrap, .main-wrap') || {}).length || 1;

    // Early exit for noRooms
    const noAvailability = document.querySelector('.no-rooms-available');
    const disabledCalendar = (!document.querySelector('.first-visibe-day') && !document.querySelector('.show-departure'));
    if ((noAvailability || disabledCalendar) && (widgetData.dateBegin && widgetData.dateEnd && widgetData.rooms && widgetData.guests)) {
      this.logger.debug('-----  NO ROOMS AVAILABLE  -----');
      widgetData.noRooms = true;
      return widgetData;
    }
    // Prices & Currency
    const prices = [...document.querySelectorAll('#rooms-grid > div:nth-child(1) .room-lowest-price:not(.not-availablep),.rate-item .price')].map((el) => {
      const cloneElem = el.cloneNode(true); // Clone the element to avoid side effects
      const oldPrice = cloneElem.querySelector('span.line-through');

      // When a promo code is applied, a old price appears within a span, so we remove it before returning the price
      if (oldPrice) {
        cloneElem.removeChild(oldPrice);
      }

      const priceText = cloneElem?.textContent?.replace(/'/, '');

      return thn.parseNumber(priceText);
    }).filter(Boolean);

    const isPriceSpecial = !!thn.parseUrlParameter('roomtype') || (window.location.pathname.match(/packages|angebot/) && !thn.widgets.price.getPromocode().promocode);
    if (isPriceSpecial) {
      widgetData.priceSpecial = 1;
    }

    if (widgetData.dateBegin && widgetData.dateEnd && !thn.empty(prices)) {
      widgetData.price = Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.set = true;
    } else if (noAvailability && widgetData.dateBegin && widgetData.dateEnd && widgetData.rooms && widgetData.guests) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_276
   * @this thn.widgets.price
   * @see {@link Price#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceParseData_v2 = function priceParseData_v2(ctx) {
    // Define empty widgetData in case that we need to do an early exist (single room case)
    // we must return or an empty object or a widgetData with all the data.
    // In this case, widgetData is all defined in price_parse_data_v1 (single room)
    // and we don't want to override those values, so we return the empty object
    let widgetData = {};

    if ((document.querySelectorAll('#rooms-grid > div') || {}).length < 2) {
      return widgetData;
    }
    // We know that there're multiple rooms, is safe to obtain price_parse_data_common
    // Add exception here if possible
    widgetData = engine._priceParseDataCommon();

    this.logger.debug('-----  MULTIPLE ROOMS  -----');

    widgetData.price = 0;
    widgetData.adults = 0;
    widgetData.children = 0;

    const guestsArray = [...document.querySelectorAll('#rooms-grid > div .room-config-wrap p')].map((el) => (el.textContent || '').match(/\s(\d[^.])/g));

    let totalPrice = 0;

    if (guestsArray) {
      for (let i = 0; i < guestsArray.length; i += 1) {
        const adults = parseInt(guestsArray[i][0] || '1', 10);
        const children = parseInt(guestsArray[i][1] || '0', 10);

        const prices = [...document.querySelectorAll(`#rooms-grid > div:nth-child(${i + 1}) .room-lowest-price:not(.not-available)`)];

        if (prices.length) {
          totalPrice += thn.parseNumber(prices[0].textContent || '0') || 0;
        }

        // Store number of guests
        widgetData.adults += adults;
        widgetData.children += children;
      }

      widgetData.guests = widgetData.adults + widgetData.children;
      widgetData.rooms = guestsArray.length || 1;
    }

    // Early exit for noRooms
    if (document.querySelector('.no-rooms-available') && widgetData.dateBegin && widgetData.dateEnd && widgetData.rooms && widgetData.guests) {
      this.logger.debug('-----  NO ROOMS AVAILABLE  -----');
      widgetData.noRooms = true;
      return widgetData;
    }

    if (widgetData.dateBegin && widgetData.dateEnd && totalPrice) {
      widgetData.price = totalPrice / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.set = true;
    } else if (widgetData.dateBegin && widgetData.dateEnd && widgetData.guests && widgetData.rooms) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_276
   * @this thn.widgets.booking
   * @see {@link Booking#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.bookingParseData = function bookingParseData(ctx) {
    const widgetData = {};
    const datalayer = window.dataLayer;
    const bookingId = (document.querySelector('.booking-number span') || {}).textContent || (datalayer && (thn.objectGet(datalayer, 'transactionId', { first: false }) || ''));

    if (bookingId) {
      widgetData.bookingId = bookingId;

      let dateBeginData = ((document.querySelector('.check-in-info > div > h5') || {}).textContent || '').trim().match(/\d+\.\d+\.\d+$/) || (datalayer && (thn.objectGet(datalayer, 'arrival', { first: false }) || '')) || '';
      let dateEndData = ((document.querySelector('.check-in-info > div:nth-child(3) > h5') || {}).textContent || '').trim().match(/\d+\.\d+\.\d+$/) || ((datalayer && (thn.objectGet(datalayer, 'departure', { first: false }))) || '') || '';
      dateBeginData = !thn.empty(dateBeginData) ? dateBeginData[0].replace(/(\d+)\.(\d+)\.(\d+)/, '$3/$2/$1') : '';
      dateEndData = !thn.empty(dateEndData) ? dateEndData[0].replace(/(\d+)\.(\d+)\.(\d+)/, '$3/$2/$1') : '';
      if (dateBeginData && dateEndData) {
        widgetData.dateBegin = dateBeginData;
        widgetData.dateEnd = dateEndData;
      }

      // If client selects multiple rooms it creats a new node with total price. So in that case we take that price, if not, normal price selector.
      const priceElMultipleRooms = (document.querySelector('#price-total') || {}).textContent || '';
      const priceElOneRoom = (document.querySelector('.confirmation-summary > div:last-child div.text-right h4') || document.querySelector('#total-paid') || {}).textContent || '';
      const priceFromDatalayer = (datalayer && (thn.objectGet(datalayer, 'transactionTotal', { first: false }) || ''));
      const price = thn.parseNumber(priceElMultipleRooms || priceElOneRoom || priceFromDatalayer);

      let currency = '';
      const currencyMatch = priceElOneRoom.trim().match(/\s(.+)$/) || {};
      const currencyFromDatalayer = (datalayer && (thn.objectGet(datalayer, 'currencyCode', { first: false }) || ''));

      if ((currencyMatch && !thn.empty(currencyMatch[1])) || currencyFromDatalayer) {
        currency = !thn.empty(currencyMatch[1]) ? thn.parseCurrency(currencyMatch[1]) : currencyFromDatalayer;
      }

      if (price && currency) {
        widgetData.price = price;
        widgetData.currency = currency;
      }
    } else { // early exit in case the card fails
      widgetData.set = false;
    }
    return widgetData;
  };

  return engine;
}

export { factory };
